module.exports = __webpack_public_path__ + "static/media/veriDART logo.496f382e.png";